import { render, staticRenderFns } from "./_ChannelFormEditor.vue?vue&type=template&id=753eac5b&scoped=true&"
import script from "./_ChannelFormEditor.vue?vue&type=script&lang=ts&"
export * from "./_ChannelFormEditor.vue?vue&type=script&lang=ts&"
import style0 from "./_ChannelFormEditor.vue?vue&type=style&index=0&id=753eac5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753eac5b",
  null
  
)

export default component.exports